import React from 'react';
import { Card, Group, Text, Badge, Button, Box } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { SourceIcon } from '../../../../utils/SourceIcon';
import { AvailableIntegration } from '@bageltechnologies/bagel-common';
import { useConnectedIntegrations } from '../../../../hooks/useIntegrations';
import { IconSettings, IconPlus } from '@tabler/icons';

interface IntegrationCardProps {
  integration: AvailableIntegration;
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({ integration }) => {
  const navigate = useNavigate();
  const { data: connectedIntegrations } = useConnectedIntegrations();

  const isConnected = connectedIntegrations?.some(
    (conn) => (conn.key === integration.key) && (['active', 'setup'].includes(conn.status || ''))
  );

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ height: '100%' }}>
      <Card.Section p="md">
        <Group position="apart" align='flex-start'>
          <Box>
            <SourceIcon sourceName={integration.key} width={40} height={40} />
            <Text weight={500} size="lg">
              {integration.name}
            </Text>
          </Box>
          <Badge 
            color={isConnected ? 'green' : 'gray'}
            variant="dot"
            styles={{
              inner: {
                color: isConnected ? '#40c057' : 'gray',
              },
              root: {
                borderColor: isConnected ? '#40c057' : 'gray',
              },
            }}
          >
            {isConnected ? 'Connected' : 'Not Connected'}
          </Badge>
        </Group>
        <Text size="sm" color="dimmed">
          {integration.description}
        </Text>
      </Card.Section>

      <Group mt="md" position="right">
        <Button
          variant={isConnected ?   "default" :"light" }
          radius="md"
          color={isConnected ? 'green' : 'indigo'}
          leftIcon={isConnected ? <IconSettings size={16} /> : <IconPlus size={16} />}
          onClick={() => navigate(`/settings/integrations2.0/${integration.key}`)}
        >
          {isConnected ? 'Manage' : 'Connect'}
        </Button>
      </Group>
    </Card>
  );
}; 